import { render, staticRenderFns } from "./KentStaffIDCard.vue?vue&type=template&id=c7a188a8&scoped=true&"
import script from "./KentStaffIDCard.vue?vue&type=script&lang=js&"
export * from "./KentStaffIDCard.vue?vue&type=script&lang=js&"
import style0 from "./KentStaffIDCard.vue?vue&type=style&index=0&id=c7a188a8&lang=scss&scoped=true&"
import style1 from "./KentStaffIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a188a8",
  null
  
)

export default component.exports